import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { Colors } from '../../styles/vars';
import Separator from './Separator';

const DropdownContentList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  padding: ${props => {
    if (props.$asFooter) {
      return '0';
    }

    if (props.$withFooter) {
      return '8px 0 0 0';
    }

    return '8px 0';
  }};

  list-style: none !important;

  ${props =>
    props.$asFooter &&
    css`
      background: ${Colors.lighterGrey};
    `}
`;

const DropdownContentItem = styled.li`
  color: ${Colors.black};
  font-size: 12px;
  line-height: 15px;
  text-decoration: none;
  background: none;
  border: none;
  outline: none;

  z-index: 1;

  @media print {
    display: none;
  }

  ${props =>
    props.$inert &&
    css`
      &:first-child,
      &:last-child,
      &:empty {
        display: none;
      }
    `}

  ${props =>
    !props.$inert &&
    css`
      > *:not(ul) {
        display: flex;
        justify-content: ${props.$align};
        width: 100%;
        padding: 10px 16px;

        font-size: inherit;
        border-radius: 0 !important;
      }
    `}
`;

const DropdownContentFooter = styled(DropdownContentItem)`
  margin-top: 8px;
  border-top: 1px solid ${Colors.lighterGrey};
`;

export const DropdownContent = ({ align, children }) => {
  if (children) {
    const items = React.Children.map(children, child => {
      if (child && React.isValidElement(child)) {
        return React.cloneElement(child, { align });
      }

      return child;
    });

    const hasFooter = items.some(child => child && child.type.isDropdownFooter);

    return (
      <DropdownContentList $align={align} $withFooter={hasFooter}>
        {items}
      </DropdownContentList>
    );
  }

  return null;
};

DropdownContent.propTypes = {
  align: PropTypes.oneOf(['start', 'center', 'end']),
  children: PropTypes.node.isRequired,
};

DropdownContent.defaultProps = {
  align: 'center',
};

export const DropdownItem = ({ inert, align, children }) => {
  return (
    <DropdownContentItem $inert={inert} $align={align}>
      {children}
    </DropdownContentItem>
  );
};

DropdownItem.propTypes = {
  inert: PropTypes.bool,
  align: PropTypes.oneOf(['start', 'center', 'end']),
  children: PropTypes.node.isRequired,
};

DropdownItem.defaultProps = {
  inert: false,
  align: 'center',
};

export const DropdownFooter = ({ inert, align, children }) => {
  return (
    <DropdownContentFooter $inert={inert} $align={align}>
      <DropdownContentList $asFooter>{children}</DropdownContentList>
    </DropdownContentFooter>
  );
};

DropdownFooter.isDropdownFooter = true;

DropdownFooter.propTypes = {
  inert: PropTypes.bool,
  align: PropTypes.oneOf(['start', 'center', 'end']),
  children: PropTypes.node.isRequired,
};

DropdownFooter.defaultProps = {
  inert: false,
  align: 'center',
};

export const DropdownSeparator = () => {
  return (
    <Separator
      color={Colors.white}
      style={{ margin: '4px 16px' }}
      ruleStyle={{ margin: '0px' }}
    />
  );
};
